import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Alegeți planul de start <br/> Noi ne ocupăm de tot, <underline>TU</underline> te relaxezi 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Plătește mai târziu din vânzări',
    [BillingMode.Stripe]: '(0)[Plătește acum];(1-inf)[Plătește acum (economisește până la {{discount}})]',
  },
};
